import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import '../App.css';
import { Link } from 'react-router-dom';
import { Grid } from "react-loader-spinner";
import { useTranslation } from 'react-i18next';
import WonAuctionBadge from './WonAuctionBadge';

class ChitCard extends React.Component {
  render() {
    const chit = this.props.chit;
    let nextAuctionDateObject = new Date(chit.next_auction_date);
    var options = { year: 'numeric', month: 'short', day: 'numeric', weekday: 'short' };
    let nextAuctionDate = nextAuctionDateObject.toLocaleDateString("en-IN", options);

    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'INR',

      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    const totalAmount = formatter.format(chit.total_members * chit.per_person_amount);
    const installmentAmount = formatter.format(chit.per_person_amount);

    return (
      <Link to={`/chit/${chit.id}`}>
        <div className="max-w-sm rounded-md overflow-hidden shadow-lg px-6 py-4 bg-blue-300 mt-4 cursor-pointer">
          <div className="flex mb-2">
            <div className="font-bold text-gray-800 text-xl mr-2">{nextAuctionDate}</div>
            <div className="rounded-md h-6 w-6 px-6 flex items-center justify-center bg-blue-200 text-gray-800">
              {chit.next_installment_count}/{chit.total_members}
            </div>
          </div>
          <div className="flex flex-row justify-between">
            <div className="flex flex-col w-10/12 break-words">
              <div className="text-gray-800 text-base">
                {chit.chit_name}
                <WonAuctionBadge showBadge={chit.won_installment_number != null} />
              </div>
              <div className='flex flex-row mt-1'>
                <div className="text-gray-800 text-base mr-2">{installmentAmount}</div>
                <div className="text-gray-700 text-base">({totalAmount})</div>
              </div>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

class MonthHeader extends React.Component {
  render() {
    const month = this.props.month;
    return (
      <h5 className="mt-8 font-black">{month}</h5>
    );
  }
}

class UpcomingTab extends React.Component {
  render() {
    const rows = [];
    let lastMonth = null;

    this.props.chits.forEach(chit => {
      let nextAuctionDateObject = new Date(chit.next_auction_date);
      var options = { year: 'numeric', month: 'short' };
      let nextInstallmentMonth = nextAuctionDateObject.toLocaleDateString("en-IN", options);
      if (!chit.is_completed) {
        if (nextInstallmentMonth !== lastMonth) {
          rows.push(
            <MonthHeader key={"month_" + chit.id} month={nextInstallmentMonth} />
          );
        }
        rows.push(
          <ChitCard key={chit.id} chit={chit} />
        );
        lastMonth = nextInstallmentMonth;
      }
    });

    return (
      <div className="mx-auto sm:max-w-xs mb-4">
        <h4 className="text-lg font-extrabold mt-4 tracking-normal">
          {this.props.t('text.upcomingInstallments')}
        </h4>
        {rows}
      </div>
    );
  }
}

const ChitList = () => {
  const { t } = useTranslation();
  const [chits, setChits] = useState([]);
  const [errorText, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchChits().catch(console.error);
  }, []);

  const fetchChits = async () => {
    let { data: chits, error } = await supabase
      .from("chits")
      .select("*")
      .is('is_archived', false)
      .order('next_auction_date', { ascending: true });
    if (error) {
      setError("No chits were created yet");
      setLoading(false);
      console.log("error", error);
    } else {
      setChits(chits);
      setLoading(false);
    }
  }

  return (
    <div className="container flex flex-col justify-center">
      {
        loading ?
          <div className="container flex px-4 py-4 mt-8 text-lg font-medium">
            <div className="mx-auto">
              <Grid type="Grid" color="#93C5FD" height="32" width="32" />
            </div>
          </div> :
          errorText ?
            <div className="container flex content-center px-4 py-4 text-lg font-medium">
              <p className="mx-auto">{errorText}</p>
            </div> :
            <div className="flex justify-center">
              <div className="w-10/12 sm:max-w-xs">
                {
                  (chits.length > 0) ? <UpcomingTab chits={chits} t={t} /> :
                    <div className="container flex px-4 py-4 text-lg font-medium">
                      <p className="mx-auto">{t('text.addChitDetailsMessage')}</p>
                    </div>
                }
                <Link to="/add">
                  <div className="fixed z-10 bottom-0 right-0 rounded-full flex items-center justify-center px-2 py-2 ml-4 mr-4 mt-8 mb-4 bg-blue-500 text-gray-900 shadow cursor-pointer bg-opacity-75 sm:relative sm:max-w-xs sm:mx-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
      }
    </div >
  );
}

export default ChitList;
